import React, {useState, useEffect, useRef} from 'react';
import UseModal from "components/modal/useModal";
import Chip from "components/chip/chip";
import Button from "components/button";
import {Delete, Dots, Modify} from "assets/icons";
import useFetchData from "hooks/useFetchData";
import UseContext from "hooks/useContext";
import TableCell from "./TableCell";

const TbodyAdmin = ({champsBody}) => {
    const {toggle}=UseModal()
    const {setAdminData}=UseContext()
    const {userData}=useFetchData()
    const [dropdownOpenId, setDropdownOpenId] = useState(null);
    const [selectedId, setSelectedId] = useState(null);
    const dropdownRefs = useRef({});
    const buttonRefs = useRef({});
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
    const token = localStorage.getItem('xsrfToken')
    
    const handleDots = (itemId, e) => {
        e?.stopPropagation();
        if (dropdownOpenId === itemId) {
            setDropdownOpenId(null);
        } else {
            // Calculer la position du dropdown
            const buttonRef = buttonRefs.current[itemId];
            if (buttonRef) {
                const rect = buttonRef.getBoundingClientRect();
                setDropdownPosition({
                    top: rect.bottom + window.scrollY + 4,
                    left: rect.right + window.scrollX - 192, // 192px = w-48 (largeur du dropdown)
                });
            }
            setDropdownOpenId(itemId);
        }
    };

    // Mettre à jour la position du dropdown lors du scroll/resize
    useEffect(() => {
        const updateDropdownPosition = () => {
            if (dropdownOpenId !== null) {
                const buttonRef = buttonRefs.current[dropdownOpenId];
                if (buttonRef) {
                    const rect = buttonRef.getBoundingClientRect();
                    setDropdownPosition({
                        top: rect.bottom + window.scrollY + 4,
                        left: rect.right + window.scrollX - 192,
                    });
                }
            }
        };

        if (dropdownOpenId !== null) {
            window.addEventListener('scroll', updateDropdownPosition, true);
            window.addEventListener('resize', updateDropdownPosition);
        }

        return () => {
            window.removeEventListener('scroll', updateDropdownPosition, true);
            window.removeEventListener('resize', updateDropdownPosition);
        };
    }, [dropdownOpenId]);

    // Fermer le dropdown quand on clique ailleurs
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Vérifier si le clic est en dehors du dropdown actuellement ouvert
            if (dropdownOpenId !== null) {
                const openDropdownRef = dropdownRefs.current[dropdownOpenId];
                const buttonRef = buttonRefs.current[dropdownOpenId];
                if (openDropdownRef && !openDropdownRef.contains(event.target) && 
                    buttonRef && !buttonRef.contains(event.target)) {
                    setDropdownOpenId(null);
                }
            }
        };

        if (dropdownOpenId !== null) {
            // Utiliser un délai pour permettre au clic de se propager d'abord
            const timeoutId = setTimeout(() => {
                document.addEventListener('mousedown', handleClickOutside);
            }, 0);

            return () => {
                clearTimeout(timeoutId);
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }
    }, [dropdownOpenId]);

    const contentAdmin={
        200:'Observateur',
        205:'Manageur',
        210:'Responsable',
        215:'Directeur',
        220:'Superviseur',
        225:'Administrateur'
    }

const handleUser=(i)=>{
        if(userData.email === i ){
            return'WARNING'
        }else{
            return 'PRIMARY'
        }
}

    // Fonction pour obtenir les initiales
    const getInitials = (firstname, lastname) => {
        const firstInitial = (firstname || '').charAt(0).toUpperCase();
        const lastInitial = (lastname || '').charAt(0).toUpperCase();
        const initials = (firstInitial + lastInitial).trim();
        return initials || '--';
    };

const handleModify = (e,i) => {
        e.preventDefault()
        e.stopPropagation();
        setDropdownOpenId(null);
setAdminData({
    id:i._id,
    email:i.email,
    firstname:i.firstname,
    lastname:i.lastname,
    role:i.role,
    token: token
})
toggle('admin_u_modify')
}

const handleDeleted = (e,i) => {
    e.preventDefault()
    e.stopPropagation();
    setDropdownOpenId(null);
    setAdminData({
        id:i._id,
        email:i.email,
        firstname:i.firstname,
        lastname:i.lastname,
        role:i.role,
        token: token
    })
    toggle('admin_d_delete')
}

    return (
        <>
            {champsBody.map((item, index) => {
                const isSelected = selectedId === item._id || selectedId === index;
                const isDropdownOpen = dropdownOpenId === item._id;
                return (
            <tr 
                key={item._id || index}
                className={`${isSelected ? 'bg-yellow-50' : 'hover:bg-gray-50'} transition-colors`}
            >
                <TableCell position="first" className="min-w-[400px]">
                    <div className={'flex items-center gap-4'}>
                        <div className="min-w-[40px] w-[40px] h-[40px] rounded-full bg-gray-100 flex items-center justify-center shrink-0">
                            <span className="text-sm font-medium text-gray-700">
                                {getInitials(item.firstname, item.lastname)}
                            </span>
                        </div>
                        <div className="flex flex-col items-start justify-center min-w-0 flex-1">
                            <p className="text-gray-900">{item.firstname} {item.lastname} {item.role === 225 ? '(vous)' : null}</p>
                            <p className="text-gray-500">{item.email}</p>
                        </div>
                    </div>
                </TableCell>
                <TableCell className="min-w-[200px]">
                    <div className={'flex gap-4'}>
                        <Chip type={'INDICATOR'} color={handleUser(item.email)}>{contentAdmin[item.role]}</Chip>
                        {item.validation != 2 ? <Chip type={'INDICATOR'} color={'PRIMARY'}>En attente</Chip> : ''}
                    </div>
                </TableCell>
                {item.role === 225 ? null : (
                    <>
                        <TableCell position="last" className="min-w-[80px]">
                            <div 
                                ref={(el) => (buttonRefs.current[item._id] = el)}
                                className="flex items-center justify-end"
                            >
                                <Button 
                                    size={'TABLE'} 
                                    color={'TABLE'}
                                    onClick={(e) => {
                                        handleDots(item._id, e);
                                    }}
                                >
<Dots w={14} h={4} color={'#374151'}/>
</Button>
                            </div>
                        </TableCell>
                        {/* Dropdown rendu en dehors de la table avec fixed positioning */}
                        {isDropdownOpen && (
                            <div 
                                ref={(el) => (dropdownRefs.current[item._id] = el)}
                                className="fixed border-2 border-[#F3F4F6] rounded-lg shadow-lg w-48 px-4 py-2 z-[9999] bg-gray-50 flex flex-col gap-2"
                                style={{
                                    top: `${dropdownPosition.top}px`,
                                    left: `${dropdownPosition.left}px`,
                                }}
                            >
                                <div className='flex flex-row items-center gap-3 cursor-pointer ft-sm hover:bg-gray-100 rounded px-2 py-1'
             onClick={(e)=>{handleModify(e,item)}}>
            <Modify wh={14} color={'#111827'}/>
            Modifier
        </div>
        <div
                                    className='flex flex-row items-center gap-3 cursor-pointer ft-sm text-red-600 hover:bg-gray-100 rounded px-2 py-1'
            onClick={(e)=>{handleDeleted(e,item)}}>
            <Delete wh={14} color={'#DC2626'}/>
            Supprimer
        </div>
    </div>
                        )}
                    </>
                )}
            </tr>
            );
            })}

        </>
    );
};

export default TbodyAdmin;